import React from 'react';
import PropTypes from 'prop-types';
import pym from 'pym.js';

const IFrame = ({ data, arcId }) => {
  const uniqID = data.divId || arcId;
  const iframeUrl = data.iframe;

  React.useEffect(() => {
    // eslint-disable-next-line no-unused-vars
    const pymParent = new pym.Parent(uniqID, iframeUrl, {});
  }, [iframeUrl, uniqID]);
  return (<div id={uniqID} className="content" />);
};

IFrame.defaultProps = {
  data: {},
};

IFrame.propTypes = {
  data: {
    iframe: PropTypes.string.isRequired,
    divId: PropTypes.string,
  },
  arcId: PropTypes.string.isRequired,
};

export default IFrame;
